import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioStep2 {

	constructor(private mainScenario: MainTutorialScenario, private onDone: () => void) {
	}

	public start() {
		this.step2RotateCameraNoBystander();
	}

	step2RotateCameraNoBystander() {
		var context = this;
			context.mainScenario.playSound('2', '3', () => {
			});
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Please drag the glowing button left and right. KB: Highlight circle, then press and hold the left then right arrow keys.'});
				context.mainScenario.rotateCameraNew( false, 0.99, 1, () => context.step2OnRotateCameraNoBystanderIsSufficient(), () => context.step2OnRotateCameraNoBystanderIsNotSufficient());
	}

	step2OnRotateCameraNoBystanderIsSufficient() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.RotateCamera);
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
		setTimeout(() => {
			context.onDone();
		}, 2000);
		// context.mainScenario.showTryAgainUI(false, false,
		// 	() => context.step2RotateCameraNoBystander(),
		// 	() => context.onDone()); //context.step3RotateCameraWithByStander()
	}

	step2OnRotateCameraNoBystanderIsNotSufficient() {
		//nothing to do here
	}
}